import React from 'react';
import GenericSelectBox from '../generic/GenericSelectBox';

/**
 * Present the current Tenant and an optional list of Local Runtimes for publishing a Flow
 *
 * @param {String} flowName the name of the Flow to be published
 * @param {Object} tenant the current tenant details
 * @param {Array} runtimes list of local runtimes
 * @param {Function} onChange handler for Select box
 */
const ActivateRuntime = ({ flowName, tenant, runtimes, onChange }) => (
    <React.Fragment>
        <p className="activate-runtime-header">
            {`Please select the runtime environment you wish to publish ${flowName} to.`}
        </p>
        <GenericSelectBox onFilter={onChange} selected={tenant.id}>
            <option key={tenant.id} value={tenant.id}>{tenant.developerName}</option>
            {
                runtimes.map(runtime => <option key={runtime.id} value={runtime.id}>{runtime.developerName}</option>)
            }
        </GenericSelectBox>
    </React.Fragment>
);

export default ActivateRuntime;
